export const sxSelect = {
    // border: '1px solid yellow',
    background: 'white',
    boxShadow: 'none',
    '.MuiOutlinedInput-notchedOutline': { border: 'none' },
    fontWeight: 400,
    fontSize: '14px',
    maxHeight: '60px',
    padding: '3px 3px',
    '& .MuiSelect-icon': {
        color: '#929292'
    }
}

export const sxMenuPaper = {
    border: '1px solid #8a05be',
    // width: '90%',
    maxWidth: '500px',
    // height: 'calc(100% - 116px)',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
}

export const sxChipSelect = {
    backgroundColor: 'white',
    borderRadius: '5px',
    border: 'grey 1px solid',
    display: 'flex',
    justifyContent: 'space-between',
    height: '25px'
}

export const sxBoxRenderValue = {
    // justifyContent: 'space-between',
    gap: 0.5,
    maxHeight: '60px',
    overflowY: 'scroll',
    padding: '5px',
    display: "flex",
    flexWrap: "wrap"
}

export const Form = {
    width: '100%',
    color: 'black'
}
